import React from 'react';
import NewWindow from 'react-new-window';
import Cookies from 'universal-cookie';
import APIManager from '../../actions/APIManager';
import * as actions from '../../actions/GlobalActions';
import axios from 'axios';
import querystring from 'querystring-es3';
import useNavigate from '../../hooks/useNavigate';


class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    }
    let token;

  }

  componentDidMount() { 
    // create a CSRF token and store it locally
    this.token = window.crypto.randomUUID();
    const cookies = new Cookies();
    cookies.set('latestCSRFToken', this.token);
  }

  handleModalClose = () => {
    if ( this.props.endpoint && this.props.variables && this.props.method) { 
      let variables = this.props.variables;

      if ( this.props.action && this.props.action === 'sso_login' ) {

        // Special case 'state' variable is replaced with the CSRF token
        if (variables.state !== undefined) {
          variables.state = this.token;
        }

        const response = actions.sso_login(process.env.REACT_APP_API_URL+this.props.endpoint,variables)
          .then( (response) => {
            if (response && response.success) {
              if (response.user_type === 'timeclock') {
                this.props.onClose && this.props.onClose({"navigate":'/user/timeclock'});
              } else {
                this.props.onClose && this.props.onClose({"navigate":'/user/dashboard'});
              }
              return;
            } else {
              this.setState({
                msg: 'Invalid credentials',
                loading: false,
              });
            }
          });
      }  // end sso_login

    } else {
      this.props.onClose && this.props.onClose();
    }

    this.setState({ open: false });
  };

  openModalWindow = () => {
    this.setState({ open: true });
  }

  render() {
    const { open } = this.state;
    const size_in_chars = this.props.size ?? 30;
    const sx = {width: `${size_in_chars}ch`};

    return (
      <div>
        { this.props.img && (
          <button style={{border: 'none'}} onClick={this.openModalWindow}> <img style={{margin: '0 auto'}} src={require('../../img/'+this.props.img)} /> </button>
        )}
        { this.props.label && (
          <button style={sx} className={this.props.class} onClick={this.openModalWindow}>{this.props.label}</button>
        )}
        { open && (
          <NewWindow
              key={"modal" + this.props.name}
              title={this.props.label}
              url={this.props.url.replace(/{{state}}/,this.token)}
              onUnload={this.handleModalClose} 
          />
        )}
      </div>
    );
  }
}

export default Modal;

